import React, { useState, useRef } from "react";
import Axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "bootstrap/dist/css/bootstrap.min.css";

import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Image,
  Breadcrumb,
} from "react-bootstrap";
import ProgressBar from "react-scroll-progress-bar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneAlt, faEnvelope ,faSearchLocation } from "@fortawesome/free-solid-svg-icons";
import { faSkype } from "@fortawesome/free-brands-svg-icons";

import { toast } from "react-toastify";

import ScrollAnimation from "react-animate-on-scroll";

import {} from "@fortawesome/free-brands-svg-icons";

import { Helmet } from "react-helmet";
import "./Contact.scss";
import { faMobileAlt } from "@fortawesome/free-solid-svg-icons";
const hourBase = "./asessts/images/web-develpment/hour-base.svg";
const projectBase = "./asessts/images/web-develpment/project-base.svg";
const dedicatedDeveloper =
  "./asessts/images/web-develpment/dedicated-developers.svg";
  const notSure = "./asessts/images/web-develpment/not-sure.svg";
  const call_1 = "./asessts/images/web-develpment/call_1.svg";


const SEO = () => {
  return (
    <Helmet>
      <title>Contact Us - Wellcreator</title>
      <meta name="title" content="Contact Us - Wellcreator" />
      <meta
        name="description"
        content="Contact Us to get a qoute for your project, or for a services or solution, you require from Wellcreator"
      />
      <meta name="keywords" content="Wellcreator, contact us Wellcreator" />
      <link
        rel="canonical"
        href="https://www.wellcreator.com/contact-us"
      ></link>
    </Helmet>
  );
};
const instagram = "./asessts/images/instagram.png";

function ContactUs() {
  const [validated, setValidated] = useState(false);
  const [contact, setContact] = useState([]);
  const [btnDisabled, setBtnDisabled] = useState(false);

  const nameRef = useRef();
  const emailRef = useRef();
  const numberRef = useRef();
  const requirmentRef = useRef();
  const messageRef = useRef();

  const submit = async (event) => {
    event.preventDefault();
    Axios({
      method: "post",
      url: process.env.REACT_APP_API_URL + "contact",
      data: {
        name: nameRef.current.value,
        email: emailRef.current.value,
        number: numberRef.current.value,
        requirment: requirmentRef.current.value,
        message: messageRef.current.value,
      },
    }).then((res) => {
      toast.success("Successfully Submitted");
      setBtnDisabled(true);
    });
  };

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  return (
    <>
      <SEO />
      <div>
        <ProgressBar />
      </div>
      {/* ***********************hero (contact us )********************** */}
      <Container className="generalHero  px-lg-4 px-3 pt-3">
        <div className="d-flex justify-content-start " id="form">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Contact us</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </Container>
      {/* ***********************hero (contact us ) END********************** */}

      <Container className=" text-md-start text-center   contactQuestion">
        {/* Left  Content */}
        <Row className="px-lg-3 ">
          <Col md={7} className=" content_contact px-3     ">
            <h1 className="heading_contact">
              Let's start a project
              <br /> together
            </h1>
            <p className="para_contact">
              We'll contact you within a couple of hours to schedule a <br />{" "}
              meeting to discuss your goals.
            </p>
          </Col>

          {/* Right Form  */}
          <Col md={5} className="right_form p-1 sm:p-2 lg-p-3 ">
            <Row className="form_row">
              <ScrollAnimation animateIn="animate__fadeIn" delay={130}>
                <div className="form_div">
                  <Form >
                    <div>
                      <h1 className="form_heading sm:text-18px ">
                        Book a free <span>Consulation</span>
                      </h1>
                      <div className="fields d-flex flex-column border-none outline-none gap-4">
                        <div className="input_field">
                          <input
                            type="text"
                            placeholder="Name"
                            class="no-border"
                          />
                        </div>
                        <div className="input_field">
                          <input type="text" placeholder="Email" />
                        </div>
                        <PhoneInput validated={validated}
                          className="mt-2 inter-phone-input"
                          country="us"
                          regions={[
                            "america",
                            "europe",
                            "asia",
                            "oceania",
                            "africa",
                          ]}
                          inputStyle={{
                            borderRadius: "0rem",
                            boxShadow: "none",
                            width: "100%",
                            padding: "19px",
                            paddingLeft: "40px",
                            border: "none",
                            borderBottom: "1px solid",
                          }}
                          dropdownStyle={{
                            width: "650%",
                            border: "none",
                            color: "black",
                          }}
                          buttonStyle={{
                            border: "none",
                            borderBottom: "1px solid",
                            backgroundColor: "white",
                          }}
                        />

                        <div className="input_field">
                          <input
                            type="text"
                            placeholder="Describe Your Project Need"
                          />
                        </div>
                      </div>
                      <p className="submit_text ">
                        By submitting this form, you agree to our{" "}
                        <a href="/privacy-policy">Privacy Policy .</a>
                      </p>
                      <div className="">
                        <button
                          type="submit"
                          className="btn_contact"
                          disabled={btnDisabled}
                          onClick={submit}
                          onSubmit={handleSubmit}
                        >
                          Get in Touch
                        </button>
                      </div>
                    </div>
                  </Form>
                </div>
              </ScrollAnimation>
            </Row>
          </Col>
        </Row>

        {/* Contact Strip */}
        <Row className="py-4  ">
          <Col
            className="social_link "
            md={6}
            sm={12}
            lg={8}
          >
            <FontAwesomeIcon icon={faMobileAlt} className="contact-phone"/>
           <h3 className="contact-help">Need help? Say Hello</h3>
            <a href="tel:+44 7354 473871 " className="contact-uk px-3">+44 7354 473871 </a>
          </Col>
          <Col
            className="social_link  "
            lg={4}
            md={6}
            sm={12}
          >
            <div className="d-flex">
            <div className="pt-3 px-3 contact-envdiv"> <FontAwesomeIcon className="contact-envelop" icon={faEnvelope} style={{fontSize:"35px"}} />{" "}</div>
               <div className="pt-3 contact-ikloc-div">   <a className="text-decoration-none contact-ukloc px-2" href="mailto:info@wellcreator.com">
                    info@wellcreator.com
                  </a>
            </div>
            </div>
          </Col>
        </Row>

        {/* =======offices cards */}
        <Row className=" flex justify-content-center mx-md-5 mt-4  px-2 mb-5">
          {/* left Card */}

          <Col className="left_card" md={4} xs={12}>
            <Card className="border-0  h-100 pic-address  p-lg-3">
              <Card.Title className="offices-address text-center mt-2">
                London
              </Card.Title>
              <Card.Img
                className="card_img"
                variant="top"
                src="../../../asessts/Image-2.svg"
              />
              <Card.Body className="px-0 py-2 px-md-2 mt-2 text-center">
                <Card.Text>
                  <p
                    className="mb-0 mb-md-0 mt-2"
                    style={{ fontSize: "0.9rem", color: "black" }}
                  >
                    93 Bennetts Castle Lane, Dagenham, England, RM8 3YB
                  </p>
                </Card.Text>
                <a
                  className="locations"
                  href="https://www.google.com/maps/place/London,+UK/@34.2487546,-3.7097788,3.33z/data=!4m23!1m16!4m15!1m6!1m2!1s0x39190483e58107d9:0xc23abe6ccc7e2462!2sLahore,+Punjab!2m2!1d74.3587473!2d31.5203696!1m6!1m2!1s0x47d8a00baf21de75:0x52963a5addd52a99!2sLondon,+United+Kingdom!2m2!1d-0.1275862!2d51.5072178!3e0!3m5!1s0x47d8a00baf21de75:0x52963a5addd52a99!8m2!3d51.5072178!4d-0.1275862!16zL20vMDRqcGw?entry=ttu"
                  target="blank"
                >
                  View Loaction
                </a>
              </Card.Body>
            </Card>
          </Col>

          {/* right Card */}
          <Col md={4} xs={12} className="mt-md-0 mt-3 right_card">
            <Card className="border-0  p-lg-3 h-100 pic-address ">
              <Card.Title className="offices-address text-center mt-2">
                {" "}
                Lahore
              </Card.Title>
              <Card.Img
                className="card_img "
                variant="top"
                src="../../../asessts/Image-6.svg"
              />
              <Card.Body className="px-0 py-2 px-md-2 mt-2 text-center">
                <Card.Text>
                  <p
                    className="mb-md-0 mt-2 mb-3"
                    style={{ fontSize: "0.9rem", color: "black" }}
                  >
                    Office # 1 G-Floor Building #43, Street # 9 Shama Road,
                    Lahore
                  </p>
                </Card.Text>
                <a
                  className="locations"
                  href="https://www.google.com/maps/dir/31.5424768,74.2785024/wellcreator+maps/@31.5451963,74.2560258,13z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x391905d0e893066b:0x79e8f4c3cbaffb80!2m2!1d74.314252!2d31.5412202?entry=ttu"
                  target="blank"
                >
                  View Loaction
                </a>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Web Developer Cards */}
        <div className="webDevCard">
          <div className="text-center">
            <Container className="py-3 py-lg-5">
              <Row className="text-center">
                <h1>
                  <span>Hire</span> Dedicated Web Developers
                </h1>
                <h3>
                  Choose How<span> YOU WANT </span>to Collaborate
                </h3>
              </Row>
              <Row className="justify-content-center pt-lg-5 px-3">
                <Col lg={3} md={6} className="py-3 h-100 py-lg-0">
                  <ScrollAnimation className="" animateIn="animate__fadeInUp">
                    <a href="#form" className="text-decoration-none">
                      <Card
                        className="  py-lg-3"
                        style={{
                          borderRadius: "10px",
                          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
                        }}
                      >
                        <Card.Body className="p-lg-2">
                          <Image
                            src={projectBase}
                            style={{ height: "50%", width: "50%" }}
                          />
                          <Card.Title className="mt-3">
                            Project-Based
                          </Card.Title>
                        </Card.Body>
                      </Card>{" "}
                    </a>
                  </ScrollAnimation>
                </Col>
                <Col lg={3} md={6} className=" py-3 h-100 py-lg-0">
                  <ScrollAnimation className="" animateIn="animate__fadeInUp">
                    <a href="#form" className="text-decoration-none">
                      <Card
                        className="  py-lg-3"
                        style={{
                          borderRadius: "10px",
                          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
                        }}
                      >
                        <Card.Body className="p-lg-2">
                          <Image
                            src={hourBase}
                            style={{ height: "50%", width: "50%" }}
                          />
                          <Card.Title className="mt-3">
                            Hire on Hourly Basis
                          </Card.Title>
                        </Card.Body>
                      </Card>
                    </a>
                  </ScrollAnimation>
                </Col>
                <Col lg={3} md={6} className="py-3 h-100 py-lg-0">
                  <ScrollAnimation className="" animateIn="animate__fadeInUp">
                    <a href="#id" className="text-decoration-none">
                      <Card
                        className="  py-lg-3"
                        style={{
                          borderRadius: "10px",
                          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
                        }}
                      >
                        <Card.Body className="p-lg-2">
                          <Image
                            src={dedicatedDeveloper}
                            style={{ height: "50%", width: "50%" }}
                          />
                          <Card.Title className="mt-3">
                            Dedicated Developers
                          </Card.Title>
                        </Card.Body>
                      </Card>
                    </a>
                  </ScrollAnimation>
                </Col>
                <Col lg={3} md={6} className="py-3 h-100 py-lg-0">
                  <ScrollAnimation className="" animateIn="animate__fadeInUp">
                    <a href="#form" className="text-decoration-none">
                      <Card
                        className="  py-lg-3"
                        style={{
                          borderRadius: "10px",
                          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
                        }}
                      >
                        <Card.Body className="p-lg-2">
                          <Image
                            src={notSure}
                            style={{ height: "50%", width: "50%" }}
                          />
                          <Card.Title className="mt-3">I'm not sure</Card.Title>
                        </Card.Body>
                      </Card>
                    </a>
                  </ScrollAnimation>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </Container>



    </>
  );
}

export default ContactUs;
